module.exports = __webpack_public_path__ + "img/1alB-i-lni.23da5c04.jpg";